import React, { useEffect, useState } from 'react';
import '../assets/styles/dashboard.css';
import { getAllUsers, createUser, deleteUser } from '../assets/constants/global_apis';
import { setCollections } from "../common_functions/slicers";
import { useSelector } from "react-redux";
import AlertPopup, { triggerAlert } from '../components/AlertMessage';
import { json } from 'react-router-dom';

const tabs = [
    { tab: 'add_user', title: 'Add User', pat: '/add-user' },
    // { tab: 'list_of_users', title: 'List of User', pat: '/list-of-users' },
]
const users = [
    { role: 'admin', title: 'Admin' }, { role: 'standard_user', title: 'Standard User' }
]
const Dashboard = () => {
    const [user, setUser] = useState({ username: '', email: '', role: '' });
    const [userList, setUserList] = useState([]);
    const [dashboardTab, setDashboardTab] = useState('add_user');
    const authToken = useSelector(state => state.authtoken);
    const [disableAddUser, setDisableAddUser] =useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser({ ...user, [name]: value });
    };

    const getUsersList = () => {
        getAllUsers().then((data) => {
            setUserList(data.users);
        }).catch((err) => {
            triggerAlert('Error', err.message);
        });
    }

    useEffect(() => {
        getUsersList();
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        setDisableAddUser(true)
        let requestData = Object.assign({}, user);
        delete requestData.id;
        createUser(requestData).then((resp) => {
            triggerAlert('Success', "User created successfully");
            setUserList([...userList,resp.user]);
            setDisableAddUser(false)
            setUser({ id: '', username: '', email: '', role: '' });
        }).catch(err => {
            setDisableAddUser(false)
            triggerAlert('Error', err.message);
        })
    };

    const handleDelete = (id) => {
        let userToDelete = userList.filter((u) => u.id == id)
        deleteUser(userToDelete[0].username).then(() => {
            triggerAlert('Success', "User deleted successfully");
            setUserList(userList.filter((u) => u.id !== id));
        }).catch(err => {
            triggerAlert('Error', err.message);
        });
    };

    return (
        <div className='dashboard-container'>
            <AlertPopup />
            <div className="col-md-3">
                <div style={{ backgroundColor: "#f8f9fa" }} className="mt-0">
                    <div className="card h-100 rounded-0  border-top-0 border-bottom-0 border-start-0 bg-transparent">
                        <div className="card-body p-0">
                            <div style={{ height: "calc(100vh - 115px)", overflow: "auto" }}>
                                <ul className="list-group">
                                    {tabs && tabs.length > 0 && tabs.map((tab, index) => (
                                        <li
                                            className={tab.tab === dashboardTab ? 'list-group-item d-flex justify-content-between align-items-center py-3 cursor-pointer explorer-list-group active' : "list-group-item d-flex justify-content-between align-items-center py-3 cursor-pointer explorer-list-group"}
                                            key={tab.tab}
                                            onClick={() => setDashboardTab(tab.tab)}
                                        >
                                            <div>
                                                {tab.title}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div></div></div>
            <div className='users-container'>
                {/* <div className="user-dashboard-container">
                    <h2>Admin Dashboard</h2>
                </div> */}
                {/* {dashboardTab && dashboardTab == 'add_user' ? */}
                <h5>Add new user</h5>
                <div>
                    <form onSubmit={handleSubmit} className="user-form">
                        <input
                            type="text"
                            name="username"
                            value={user.username}
                            onChange={handleChange}
                            placeholder="Enter Username"
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            className='email-input'
                            value={user.email}
                            onChange={handleChange}
                            placeholder="Enter Email"
                            required
                        />
                        <select
                            name="role"
                            value={user.role}
                            onChange={handleChange}
                            className="dropdown"
                            required
                        >
                            <option className='dropdown-option' value="" disabled>
                                Select Role
                            </option>
                            {users.map((user,index) =>
                                <option key={'rol_option'+index+1} value={user.role}>{user.title}</option>
                            )}
                        </select>
                        <button type="submit" className={disableAddUser ? "disabled-btn" : "btn-submit"} disabled={disableAddUser}>
                            Add User
                        </button>
                    </form>
                </div>
                {/* : */}
                <h5 className='text-left'>Users List</h5>   
                <div style={{height:'500px',overflowY:'auto'}}>
                    
                    <ul className="user-list">
                        {userList && userList.length > 0 ? userList.map((u) => (
                            <li key={u.id} className="user-list-item">
                                <div className="user-info">
                                    {u.username}
                                </div>
                                <div className="user-info">
                                    {u.email}
                                </div>
                                <div className="user-info">
                                    {u.role}
                                </div>
                                <div className="user-actions">
                                    <button onClick={() => handleDelete(u.id)} className="btn-delete">
                                        Delete
                                    </button>
                                </div>
                            </li>
                        )) : 'No data found'}
                    </ul>
                </div>
                {/* } */}
            </div>
        </div>
    );
};

export default Dashboard;
